import { z } from 'zod';
// Заявка на ручное заведение контрагента: реквизиты (как legal_entities) + цены по группам.
// payload в pending_counterparties = ManualCounterpartyRequest.
export const ManualCounterpartyRequest = z.object({
    name: z.string().min(1).max(500),
    inn: z.string().regex(/^\d{10}$|^\d{12}$/, 'ИНН: 10 или 12 цифр'),
    entityKind: z.enum(['company', 'entrepreneur']),
    ogrn: z.string().min(13).max(15).nullable().optional(),
    kpp: z.string().max(9).nullable().optional(),
    legalAddress: z.string().nullable().optional(),
    directorName: z.string().nullable().optional(),
    directorTitle: z.string().nullable().optional(),
    signatoryBasis: z.string().nullable().optional(),
    bankName: z.string().nullable().optional(),
    bankAccount: z.string().nullable().optional(),
    bankCorr: z.string().nullable().optional(),
    bankBik: z.string().nullable().optional(),
    // контакты / условия (как в КУ)
    city: z.string().nullable().optional(),
    warehouse: z.string().nullable().optional(),
    brandLabel: z.string().nullable().optional(),
    edoId: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    contactName: z.string().nullable().optional(),
    contactRole: z.string().nullable().optional(),
    telegram: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    paymentDelay: z.number().int().min(0).max(999).nullable().optional(),
    deliveryTime: z.number().int().nullable().optional(),
    creditLimit: z.number().nullable().optional(),
    pdzDelay: z.number().int().nullable().optional(),
    // цены: метка товарной группы -> цена за единицу
    prices: z.record(z.string(), z.number().nonnegative()),
});
export const PendingCounterpartyStatus = z.enum(['pending', 'approved', 'rejected']);
// Для списка заявок у админа.
export const PendingCounterpartySummary = z.object({
    id: z.string(),
    status: PendingCounterpartyStatus,
    name: z.string(),
    inn: z.string().nullable(),
    payload: ManualCounterpartyRequest, // полные реквизиты + цены для просмотра
    createdAt: z.string(),
    createdByEmail: z.string().nullable(),
    decidedAt: z.string().nullable(),
    legalEntityId: z.string().nullable(),
});
//# sourceMappingURL=manual-counterparties.js.map